/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Processing_TitleInputs */

const en_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Processing`)
};

const fr_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement audio`)
};

const de_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioverarbeitung`)
};

const it_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione audio`)
};

const ru_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка звука`)
};

const es_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento de audio`)
};

const zh_cn2_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频处理`)
};

const ja_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ処理`)
};

const hi_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो प्रोसेसिंग`)
};

const pt_pt2_audio_description_export_audio_processing_title = /** @type {(inputs: Audio_Description_Export_Audio_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Processing" |
*
* @param {Audio_Description_Export_Audio_Processing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_processing_title = /** @type {((inputs?: Audio_Description_Export_Audio_Processing_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Processing_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_audio_processing_title(inputs)
	if (locale === "de") return de_audio_description_export_audio_processing_title(inputs)
	if (locale === "it") return it_audio_description_export_audio_processing_title(inputs)
	if (locale === "ru") return ru_audio_description_export_audio_processing_title(inputs)
	if (locale === "es") return es_audio_description_export_audio_processing_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_audio_processing_title(inputs)
	if (locale === "ja") return ja_audio_description_export_audio_processing_title(inputs)
	if (locale === "hi") return hi_audio_description_export_audio_processing_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_audio_processing_title(inputs)
	return en_audio_description_export_audio_processing_title(inputs)
});